import { atom } from 'jotai'

export const navigationThemeAtom = atom<'light' | 'dark'>('light')
